import { jsx as t } from "react/jsx-runtime";
import { defaultNS as i } from "../libs/util/dist/index25.mjs";
import { createLocaleProvider as a } from "../libs/util/dist/index27.mjs";
import { isLocalizedCountriesRegistered as c, registerLocalizedCountries as n } from "../enums/countries/utilize-localized-countries.mjs";
const { LocaleContext: m, LocaleProvider: l } = a(), f = (e) => {
  var r;
  const o = (r = e.i18n) == null ? void 0 : r.getResource(e.languageCode, i, "countries");
  return o && !c(e.languageCode) && n({
    locale: e.languageCode,
    countries: o
  }), /* @__PURE__ */ t(l, { ...e });
};
export {
  m as LocaleContext,
  f as LocaleProvider
};
